<template>
  <div :style="{'--menuColor':componentStyle.backgroundColor}">
    <template v-if="pc">
      <div class="top-content" :style="componentStyle">
        <div :style="contentStyle">
          <div class="photo-content" :style="[photoStyle]" v-if="data.showImage && data.mediaImage[0].image">
            <el-image @click="toIndex(data)" :style="[photoStyle,marginStyle,{cursor:data.isJump?'pointer': ''}]" :src="data.mediaImage[0].image" :fit="data.photoMode === 'scaleToFill'? 'fill' : 'scale-down'"></el-image>
            <a v-if="data.isJump" style="display: none;" :href="indexHref"></a>
          </div>
          <template v-if="data.level < 3">
            <template v-for="item in data.list">
              <template v-if="item.children && item.children.length">
                <div class="nav-block" :style="textStyle" @mouseenter="hoverNav = item.id" @mouseleave="hoverNav = ''">
                  {{item.name}}
                  <div v-show="hoverNav == item.id" class="nav-list" :style="childContentStyle">
                    <template v-for="items in item.children">
                      <div class="nav-child" :style="childStyle" @click="toRouter(items)">{{items.name}}</div>
                      <a style="display: none;" :href="items.href">{{items.name}}</a>
                    </template>
                  </div>
                </div>
              </template>
              <div v-else class="nav-block" :style="textStyle" @click="toRouter(item)">
                {{item.name}}
                <a style="display: none;" :href="item.href">{{item.name}}</a>
              </div>
            </template>
          </template>
          <template v-else>
            <template v-for="item in data.list">
              <template v-if="item.children && item.children.length">
                <div class="nav-block2" :style="textStyle" @mouseenter="hoverNav = item.id" @mouseleave="hoverNav = ''">
                    {{item.name}}
                </div>
                <div v-show="hoverNav == item.id" class="nav-list" :style="childContentStyle" @mouseenter="hoverNav = item.id" @mouseleave="hoverNav = ''">
                  <template v-for="items in item.children">
                    <div :style="childSecondContentStyle">
                      <template v-if="items.children && items.children.length">
                        <div :style="childLabelStyle">{{items.name}}</div>
                        <template v-for="info in items.children">
                          <div class="nav-child2" :style="childStyle" @click="toRouter(info)">
                            {{info.name}}
                            <a style="display: none;" :href="info.href">{{info.name}}</a>
                          </div>
                        </template>
                      </template>
                      <div v-else class="nav-child2" :style="childStyle" @click="toRouter(items)">
                        {{items.name}}
                        <a style="display: none;" :href="items.href">{{items.name}}</a>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
              <div v-else class="nav-block2" :style="textStyle" @click="toRouter(item)">
                {{item.name}}
                <a style="display: none;" :href="item.href">{{item.name}}</a>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex-row align-center fixed-menu" @click="drawer=true">
        <div class="icon-menu"></div>
      </div>
      <el-drawer
        :visible.sync="drawer"
         :with-header="false"
        direction="rtl"
        size="80%"
        :show-close="false">
        <div class="top-content" :style="componentStyle">
          <div :style="[contentStyle,paddingStyle]">
            <div :style="[photoStyle,{width: pc?photoStyle.width:'100%'}]" v-if="data.showImage && data.mediaImage[0].image">
              <el-image @click="toIndex(data)" :style="[photoStyle,marginStyle]" :src="data.mediaImage[0].image" :fit="data.photoMode === 'scaleToFill'? 'fill' : 'scale-down'"></el-image>
              <a v-if="data.isJump" style="display: none;" :href="indexHref"></a>
            </div>
            <template v-if="data.level < 3">
              <template v-for="item in data.list">
                <template v-if="item.children && item.children.length">
                  <div class="nav-block" :style="textStyle" @click="hoverNav = item.id">
                       {{item.name}}
                  </div>
                  <div v-show="hoverNav == item.id" class="nav-list" :style="childContentStyle">
                    <template v-for="items in item.children">
                      <div class="nav-child" :style="childStyle" @click="toRouter(items)">
                        {{items.name}}
                        <a style="display: none;" :href="items.href">{{items.name}}</a>
                      </div>
                    </template>
                  </div>
                </template>
                <div v-else class="nav-block" :style="textStyle" @click="toRouter(item)">
                  {{item.name}}
                  <a style="display: none;" :href="item.href">{{item.name}}</a>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-for="item in data.list">
                <template v-if="item.children && item.children.length">
                    <div class="nav-block2" :style="textStyle" @click="hoverNav = item.id">
                        {{item.name}}
                    </div>
                    <div v-show="hoverNav == item.id" class="nav-list" :style="childContentStyle">
                      <template v-for="items in item.children">
                        <div :style="childSecondContentStyle">
                          <template v-if="items.children && items.children.length">
                            <div :style="childLabelStyle">{{items.name}}</div>
                            <template v-for="info in items.children">
                              <div class="nav-child2" :style="childStyle" @click="toRouter(info)">
                                {{info.name}}
                                <a style="display: none;" :href="info.href">{{info.name}}</a>
                              </div>
                            </template>
                          </template>
                          <div v-else class="nav-child2" :style="childStyle" @click="toRouter(items)">
                            {{items.name}}
                            <a style="display: none;" :href="items.href">{{items.name}}</a>
                          </div>
                        </div>
                      </template>
                    </div>
                </template>
                <div v-else class="nav-block2" :style="textStyle" @click="toRouter(item)">
                  {{item.name}}
                  <a style="display: none;" :href="item.href">{{item.name}}</a>
                </div>
              </template>
            </template>
          </div>
        </div>
      </el-drawer>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'top-nav',
    props: {
      websiteId: {
        type: [String,Number],
        default: ''
      },
      data: {
        type: Object,
        default(){
          return {}
        }
      }
    },
    watch:{
      data:{
        handler(v){
          let {data} = this
          const px2rem = this.$store.state.globalObj.px2rem
          Object.keys(data.style).forEach(item => {
          	if(Object.prototype.toString.call(data.style[item]) === '[object Object]'){
          		Object.keys(data.style[item]).forEach(e => {
          			if(typeof data.style[item][e] === 'number' && e !== 'fontWeight' && e !== 'lineHeight'){
          			  this[item][e] = data.style[item][e] + px2rem
                  if(px2rem == 'rem' && (e === 'fontSize' || e.indexOf('padding') > 0)){
                    this[item][e] = data.style[item][e] * 1.5 + px2rem
                  }
          			}else{
                  this[item][e] = typeof data.style[item][e] === 'string' ? data.style[item][e].replace('px',px2rem) : data.style[item][e]
                }
          		})
          	}
          })
        },
        immediate: true,
        deep: true
      }
    },
    data() {
      return {
        pc: true,
        componentStyle: {},
        contentStyle: {},
        photoStyle: {},
        textStyle: {},
        childContentStyle: {},
        childSecondContentStyle: {},
        childLabelStyle: {},
        childStyle: {},
        marginStyle: {
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
        },
        paddingStyle: {
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          paddingLeft: 0,
        },
        hoverNav: '',
        drawer: false,
        indexHref: ''
      }
    },
    created() {
      this.indexHref = `${window.location.origin}/web/new_website/index${window.location.search}`
      this.pc = this.$store.state.globalObj.pc
      if(!this.pc){
        this.componentStyle.height = this.childStyle.height = this.contentStyle.height = 'auto'
        this.contentStyle.flexDirection = this.textStyle.flexDirection = this.childContentStyle.flexDirection = 'column'
        this.childContentStyle.width = this.childSecondContentStyle.width = '100%'
        this.childContentStyle.position = 'static'
        // this.childStyle.width = '100%'
        this.photoStyle.width = `calc(${this.photoStyle.width} * 1.5)`
        this.photoStyle.height = `calc(${this.photoStyle.height} * 1.5)`
      }
    },
    methods: {
      toIndex(data){
        if(data.isJump){
          this.toRouter({url: '/'})
        }
      },
      toRouter(e){
        // type: 0 当前窗口router，1 当前窗口https链接，2 新窗口https链接
        this.hoverNav = ''
        this.drawer = false
        if(e.url == '/' || e.url == '/index'){
          this.$router.push({
            path: e.url,
            query: {
              website_id: this.websiteId
            }
          })
          return
        }
        if(e.type == 1 || e.type == 3){
          window.location.href = e.url
          return
        }
        if(e.type == 2){
          window.open(e.url)
          return
        }
        this.$router.push({path: e.url})
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .el-drawer__body{
    padding: 20px;
    background-color: var(--menuColor);
  }
  .top-content{
    position: relative;
    z-index: 999;
  }
  .photo-content{
    margin-left: var(--photoMarginRight);
    margin-right: var(--photoMarginLeft);
  }
  .fixed-menu{
    width: 80px;
    height: 80px;
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 999;
  }
  .icon-menu {
    position: relative;
    &,&::before,&::after {
      content: '';
      width: 100%;
      height: 4px;
      background-color: var(--menuColor);
    }
    &::before,&::after{
      position: absolute;
      top: -30px;
    }
    &::after {
      top: 30px;
    }
  }
  .nav-list{
    display: flex;
    position: absolute;
    z-index: 999;
  }
  .nav-block,.nav-child,.nav-block2,.nav-child2{
    display: flex;
    position: relative;
    cursor: pointer;
  }
  .nav-block:hover{
    color: var(--hoverColor) !important;
    background-color: var(--hoverBackgroundColor) !important;
  }
  .nav-child:hover {
    color: var(--hoverChildColor) !important;
    background-color: var(--hoverChildBackgroundColor) !important;
  }
  .nav-block2::after,.nav-child2::after {
        content: "";
        width: 0;
        height: 2px;
        background-color: var(--lineHoverColor);
        position: absolute;
        bottom: var(--lineHoverBottom);
        left: 50%;
        transform: translateX(-50%);
        transition: width .1s ease-in-out;
  }
  .nav-block2:hover{
    color: var(--hoverColor) !important;
    background-color: var(--hoverBackgroundColor) !important;
  }
  .nav-child2:hover {
    color: var(--hoverChildColor) !important;
    background-color: var(--hoverChildBackgroundColor) !important;
  }
  .nav-block2:hover,.nav-child2:hover {
    &::after{
      width: 100%;
      transition: width .3s ease-in-out;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top-nav.vue